<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-date-picker v-model="formDatas.year" type="year" value-format="yyyy" @change="partserch"
                        placeholder="选择年份" style="width: 160px;" size="small">
                    </el-date-picker>
                    <el-select size="small" multiple v-model="formDatas.auDepartment" clearable @change="selectChange"
                        placeholder="请选择" collapse-tags style="width: 330px" @removeTag="removeTag">
                        <el-option v-for="(item, index) in  auDepartment_arr" :label="item.name" :value="item.name"
                            :key="index"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.auBelong" style="width: 140px;" size="small" placeholder="请输入归属"
                        clearable></el-input>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">

                    <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                         :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <!-- <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div> -->
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑归属地' : '新增归属地'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="归属地名称" prop="aubName">
                                <el-input v-model="form.aubName" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjUserStatisticsYear, addAjUserBelong, updateAjUserBelong, deleteAjUserBelong, getAjUserItem } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            changeIndex: null,
            auDepartment_arr: [],
            dialog: false,
            edit: false,
            form: {
                aubName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "yearMonth",
                    key: "yearMonth",
                    title: "月份",
                    align: "center",
                    width: 80,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 80,
                },
                {
                    field: "userNumMonthBegin",
                    key: "userNumMonthBegin",
                    title: "月初人数",
                    align: "center",
                    width: 80,
                },
                {
                    field: "userNumMonthEnd",
                    key: "userNumMonthEnd",
                    title: "月末人数",
                    align: "center",
                    width: 80,
                },

                {
                    field: "userNumMonthEntry",
                    key: "userNumMonthEntry",
                    title: "入职人数",
                    align: "center",
                    width: 80,
                },
                {
                    field: "userNumMonthLeave",
                    key: "userNumMonthLeave",
                    title: "离职人数",
                    align: "center",
                    width: 80,
                },
                {
                    field: "userRateLeave",
                    key: "userRateLeave",
                    title: "离职率",
                    align: "center",
                    width: 80,
                },
                {
                    field: "userRateLeaveCiZhi",
                    key: "userRateLeaveCiZhi",
                    title: "辞职人数/占比",
                    align: "center",
                    width: 100,
                },
                {
                    field: "userRateLeaveQuanTui",
                    key: "userRateLeaveQuanTui",
                    title: "劝退人数/占比",
                    align: "center",
                    width: 100,
                },
                {
                    field: "userRateLeaveCiZhiWeek",
                    key: "userRateLeaveCiZhiWeek",
                    title: "入职当周辞职人数/占比",
                    align: "center",
                    width: 150,
                },

                {
                    field: "userRateLeaveQuanTuiWeek",
                    key: "userRateLeaveQuanTuiWeek",
                    title: "入职当周劝退人数/占比",
                    align: "center",
                    width: 150,
                },

                {
                    field: "userRateLeaveCiZhiTrail",
                    key: "userRateLeaveCiZhiTrail",
                    title: "试用期辞职人数/占比",
                    align: "center",
                    width: 150,
                },
                {
                    field: "userRateLeaveQuanTuiTrail",
                    key: "userRateLeaveQuanTuiTrail",
                    title: "试用期劝退人数/占比",
                    align: "center",
                    width: 150,
                },
                {
                    field: "userRateLeaveCiZhiYear",
                    key: "userRateLeaveCiZhiYear",
                    title: "入职一年内辞职人数/占比",
                    align: "center",
                    width: 170,
                },
                {
                    field: "userRateLeaveQuanTuiYear",
                    key: "userRateLeaveQuanTuiYear",
                    title: "入职一年内劝退人数/占比",
                    align: "center",
                    width: 170,
                },
                {
                    field: "userRateLeaveCiZhiYearTwo",
                    key: "userRateLeaveCiZhiYearTwo",
                    title: "入职两年内辞职人数/占比",
                    align: "center",
                    width: 170,
                },
                {
                    field: "userRateLeaveQuanTuiYearTwo",
                    key: "userRateLeaveQuanTuiYearTwo",
                    title: "入职两年内劝退人数/占比",
                    align: "center",
                    width: 170,
                },
                {
                    field: "userRateLeaveCiZhiYearThree",
                    key: "userRateLeaveCiZhiYearThree",
                    title: "入职两年及以上辞职人数/占比",
                    align: "center",
                    width: 190,
                },
                {
                    field: "userRateLeaveQuanTuiYearThree",
                    key: "userRateLeaveQuanTuiYearThree",
                    title: "入职两年及以上劝退人数/占比",
                    align: "center",
                    width: 190,
                },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auBelong: '',
                year: '',
                auDepartment: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjUserItem({
            item: 'auDepartment',
            itemStatus: 1
        }).then(res => {
            this.auDepartment_arr = res.data;
            this.auDepartment_arr.unshift({ name: '全部' });
        })
        this.getList();
    },
    mounted() { },
    methods: {
        removeTag(e) {
            console.log(e);

        },
        selectChange(e) {
            this.formDatas.auDepartment = e
            if (this.formDatas.auDepartment[e.length - 1] == '全部') {
                // this.formDatas.auDepartment = [];
                this.changeIndex = e.length - 1;
                this.auDepartment_arr.forEach((item, index) => {
                    if (this.formDatas.auDepartment.indexOf(item.name) == -1) {
                        this.formDatas.auDepartment.push(item.name)
                    }
                });
                this.partserch()
                return
            }
            if ( (this.changeIndex != null && this.changeIndex >= 0) && this.formDatas.auDepartment.indexOf('全部') == -1) {
                console.log('112');
                this.formDatas.auDepartment = [];
                this.changeIndex = null;
                this.partserch();
                return
            }
            if(this.formDatas.auDepartment.indexOf('全部') > -1 && this.formDatas.auDepartment.length != this.auDepartment_arr.length){
               console.log('11');
                this.formDatas.auDepartment.splice(this.formDatas.auDepartment.indexOf('全部'),1)
                this.changeIndex = null;
            }
            this.partserch();

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            const bulkdata = {
                ...this.formDatas
            }
            bulkdata.auDepartment =  bulkdata.auDepartment ? JSON.stringify(bulkdata.auDepartment):'';
            var s = qs.stringify(bulkdata);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-user-statistics/exportAjUserStatisticsYear',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '人员变动情况.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })

        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = { aubIds: row.aubId }
                    console.log(s);
                    deleteAjUserBelong({ aubIds: row.aubId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUserBelong(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjUserBelong(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aubId = row.aubId
                    console.log(jsonObj);
                    updateAjUserBelong(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aubId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aubId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aubId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aubId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aubId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjUserStatisticsYear(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            const newForm = JSON.parse(JSON.stringify(this.formDatas))
            newForm.currentPage = 1;
            newForm.auDepartment = newForm.auDepartment ? JSON.stringify(newForm.auDepartment) : '';
            getAjUserStatisticsYear(newForm).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjUserStatisticsYear(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>